import {getBvGroupFeatures} from "./server-api";
import {getCurrentLayout} from "../bvcomponents/appLayout";

let axiosController;

/**
 * renderErrorPopup can display retry connection and sign contract buttons
 * @param featureGroup {object}
 * @param searchText {string}
 * @param setShowLoader {function}
 */
export const searchProductRequest = async (featureGroup, searchText, setShowLoader = () => {}) => {
  if (!searchText || !featureGroup || featureGroup.getRealFeaturesReceivedProperty()
    || (Array.isArray(featureGroup.alreadyRequestedFeatureNames) && featureGroup.alreadyRequestedFeatureNames.includes(searchText))
  ) {
    return false
  }
  setShowLoader(true);
  if (axiosController) {
    axiosController.abort();
  }
  if (AbortController) {
    axiosController = new AbortController();
  }
  const dbName = featureGroup.dbName || featureGroup.partName;
  const pageSize = 9999;
  if (document.kvConfig.visualizerType === "bvLook") {
    const layout = getCurrentLayout();
    const wallParent = layout.parts["Walls"];
    if (featureGroup.additionalPartPartId && wallParent && wallParent.relatedItems.some(relItem => relItem.partId === featureGroup.partId)) {
      const cropResponse = await getBvGroupFeatures(dbName + " Crop", 0, pageSize, [], searchText, null, axiosController);
      if (Array.isArray(cropResponse)) {
        featureGroup.setGroupFeatures(cropResponse, pageSize, false, "", null, true, false);
      }
    }
  }
  const response = await getBvGroupFeatures(dbName, 0, pageSize, [], searchText, null, axiosController)
  if (response) {
    featureGroup.setGroupFeatures(response, pageSize, false, "", null, true);
  }
  if (!featureGroup.alreadyRequestedFeatureNames) {
    featureGroup.alreadyRequestedFeatureNames = [];
  }
  featureGroup.alreadyRequestedFeatureNames.push(searchText);
  setShowLoader(false);
  return response ? response.data : []
}
